<template>
  <table v-if="toGroup" class="detail-table">
    <tbody>
      <tr>
        <th>Tutor ID</th>
          <td>{{ toGroup.tutor.id }}</td>
      </tr>
      <tr>
        <th>Tutor name</th>
          <td>{{ toGroup.tutor.name }}</td>
      </tr>
      <tr>
        <th>Level</th>
        <td>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectLevelInput v-model="level" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </td>
      </tr>
      <tr>
        <th>day of week</th>
        <td>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectWeekdayInput v-model="dayOfWeek" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </td>
      </tr>
      <tr>
        <th>Period</th>
        <td>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectPeriodInput v-model="period" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </td>
      </tr>
      <tr>
        <th>University</th>
        <td>{{ toGroup.university.name }}</td>
      </tr>
      <tr v-show="toGroup.university">
        <th>Campus</th>
        <td>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectCampusInput v-model="campus" :belongsToUniversity="toGroup.university" />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </td>
      </tr>
      <tr v-show="campus">
        <th>Booth</th>
        <td>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <SelectBoothInput
              v-model="booth"
              :university="toGroup.university"
              :campus="campus"
            />
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import _ from 'lodash'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { Campus, Level } from '@/store/master/types'
import { Group } from '@/store/groups/types'
import { Booth } from '@/store/booths/types'
import { weekdayKey, periodType } from '@/store/common.types'
import SelectLevelInput from '@/components/parts/inputItem/SelectLevelInput.vue'
import SelectPeriodInput from '@/components/parts/inputItem/SelectPeriodInput.vue'
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import SelectCampusInput from '@/components/parts/inputItem/SelectCampusInput.vue'
import SelectBoothInput from '@/components/parts/inputItem/SelectBoothInput.vue'
import SelectWeekdayInput from '@/components/parts/inputItem/SelectWeekdayInput.vue'
import { ValidationProvider } from 'vee-validate'

@Component({
  components: {
    SelectLevelInput,
    SelectPeriodInput,
    SelectUniversityInput,
    SelectCampusInput,
    SelectBoothInput,
    SelectWeekdayInput,
    ValidationProvider,
  },
})
export default class InputForm extends Vue {
  @Prop() value!: Group

  private level: Level|null = null

  private dayOfWeek: weekdayKey|null = null

  private period: periodType|null = null

  private campus: Campus|null = null

  private booth: Booth|null = null

  private get toGroup(): Group {
    return this.value
  }

  @Watch('campus')
  private resetSelectedBooth() {
    this.booth = null;
  }

  public input(): Group {
    const newGroup = _.cloneDeep(this.value)
    return _.assignWith(newGroup, {
      level: this.level,
      dayOfWeek: this.dayOfWeek,
      period: this.period,
      campus: this.campus,
      booth: this.booth,
    }, (group, input) => (input === null ? group : input))
  }
}
</script>

<style scoped>
table.detail-table {
  width:100%;
}

table.detail-table th {
  display: block;
  text-align: left;
  margin:10px 0;
}

table.detail-table td {
  display: block;
  margin:10px 0;
}
</style>
